module.exports = __webpack_public_path__ + "img/full3-min.8cf4d5b6.png";